import RIPolicyDetails from './PolicyDetails/RIPolicyDetails';
import PolicyBilling from './Policies/Billing/Billing';
import gatewayMessages from './gateway.messages';
import LossRuns from './Policies/LossRuns/LossRuns';
import InjuryAnalysis from './Policies/InjuryAnalysis/InjuryAnalysis';
import AuditStatements from './Policies/Audits/AuditStatements';

const ripolicyComponentMap = {
    RIPolicyDetails: { component: 'RIPolicyDetails' },
};

const ripolicyComponents = {
    RIPolicyDetails
};

export {
    RIPolicyDetails,
    PolicyBilling,
    LossRuns,
    InjuryAnalysis,
    ripolicyComponentMap,
    ripolicyComponents,
    gatewayMessages,
    AuditStatements
};
